/**
 * Tracks whether an automatic popup was already shown in the running session.
 *
 * Ensures automatic popups are only shown once per session.
 */
const autoPopup = () => {
  let shown = false

  return {
    isShown: (): boolean => shown,
    markShown: () => {
      shown = true
    }
  }
}

export default autoPopup
